export const professionsList = [
	{
		codigo: '1113',
		descripcion: 'Directores de organizaciones de interés social',
	},
	{
		codigo: '1429',
		descripcion:
			'Directores y gerentes de empresas de catering y otras empresas de restauración',
	},
	{
		codigo: '1501',
		descripcion:
			'Directores y gerentes de empresas de actividades recreativas, culturales y deportivas',
	},
	{
		codigo: '1509',
		descripcion:
			'Directores y gerentes de empresas de gestión de residuos y de otras empresas de servicios no clasificados bajo otros epígrafes',
	},
	{
		codigo: '2130',
		descripcion: 'Veterinarios',
	},
	{
		codigo: '2140',
		descripcion: 'Farmacéuticos',
	},
	{
		codigo: '2151',
		descripcion: 'Odontólogos y estomatólogos',
	},
	{
		codigo: '2152',
		descripcion: 'Fisioterapeutas',
	},
	{
		codigo: '2153',
		descripcion: 'Dietistas y nutricionistas',
	},
	{
		codigo: '2154',
		descripcion: 'Logopedas',
	},
	{
		codigo: '2155',
		descripcion: 'Ópticos-optometristas',
	},
	{
		codigo: '2156',
		descripcion: 'Terapeutas ocupacionales',
	},
	{
		codigo: '2157',
		descripcion: 'Podólogos',
	},
	{
		codigo: '2158',
		descripcion: 'Profesionales de la salud y la higiene laboral y ambiental',
	},
	{
		codigo: '2159',
		descripcion: 'Profesionales de la salud no clasificados bajo otros epígrafes',
	},
	{
		codigo: '2210',
		descripcion:
			'Profesores de universidades y otra enseñanza superior (excepto formación profesional)',
	},
	{
		codigo: '2411',
		descripcion: 'Físicos y astrónomos',
	},
	{
		codigo: '2412',
		descripcion: 'Meteorólogos',
	},
	{
		codigo: '2413',
		descripcion: 'Químicos',
	},
	{
		codigo: '2414',
		descripcion: 'Geólogos y geofísicos',
	},
	{
		codigo: '2415',
		descripcion: 'Matemáticos y actuarios',
	},
	{
		codigo: '2416',
		descripcion: 'Estadísticos',
	},
	{
		codigo: '2421',
		descripcion: 'Biólogos, botánicos, zoólogos y afines',
	},
	{
		codigo: '2422',
		descripcion: 'Ingenieros agrónomos',
	},
	{
		codigo: '2423',
		descripcion: 'Ingenieros de montes',
	},
	{
		codigo: '2424',
		descripcion: 'Ingenieros técnicos agrícolas',
	},
	{
		codigo: '2425',
		descripcion: 'Ingenieros técnicos forestales y del medio natural',
	},
	{
		codigo: '2426',
		descripcion: 'Profesionales de la protección ambiental',
	},
	{
		codigo: '2427',
		descripcion: 'Enólogos',
	},
	{
		codigo: '2431',
		descripcion: 'Ingenieros industriales y de producción',
	},
	{
		codigo: '2432',
		descripcion: 'Ingenieros en construcción y obra civil',
	},
	{
		codigo: '2433',
		descripcion: 'Ingenieros mecánicos',
	},
	{
		codigo: '2434',
		descripcion: 'Ingenieros aeronáuticos',
	},
	{
		codigo: '2435',
		descripcion: 'Ingenieros químicos',
	},
	{
		codigo: '2436',
		descripcion: 'Ingenieros de minas, metalúrgicos y afines',
	},
	{
		codigo: '2437',
		descripcion: 'Ingenieros ambientales',
	},
	{
		codigo: '2439',
		descripcion: 'Ingenieros no clasificados bajo otros epígrafes',
	},
	{
		codigo: '2441',
		descripcion: 'Ingenieros en electricidad',
	},
	{
		codigo: '2442',
		descripcion: 'Ingenieros electrónicos',
	},
	{
		codigo: '2443',
		descripcion: 'Ingenieros en telecomunicaciones',
	},
	{
		codigo: '2451',
		descripcion: 'Arquitectos (excepto arquitectos paisajistas y urbanistas)',
	},
	{
		codigo: '2452',
		descripcion: 'Arquitectos paisajistas',
	},
	{
		codigo: '2453',
		descripcion: 'Urbanistas e ingenieros de tráfico',
	},
	{
		codigo: '2454',
		descripcion: 'Ingenieros geógrafos y cartógrafos',
	},
	{
		codigo: '2461',
		descripcion: 'Ingenieros técnicos industriales y de producción',
	},
	{
		codigo: '2462',
		descripcion: 'Ingenieros técnicos de obras públicas',
	},
	{
		codigo: '2463',
		descripcion: 'Ingenieros técnicos mecánicos',
	},
	{
		codigo: '2464',
		descripcion: 'Ingenieros técnicos aeronáuticos',
	},
	{
		codigo: '2465',
		descripcion: 'Ingenieros técnicos químicos',
	},
	{
		codigo: '2466',
		descripcion: 'Ingenieros técnicos de minas, metalúrgicos y afines',
	},
	{
		codigo: '2469',
		descripcion: 'Ingenieros técnicos no clasificados bajo otros epígrafes',
	},
	{
		codigo: '2471',
		descripcion: 'Ingenieros técnicos en electricidad',
	},
	{
		codigo: '2472',
		descripcion: 'Ingenieros técnicos en electrónica',
	},
	{
		codigo: '2473',
		descripcion: 'Ingenieros técnicos en telecomunicaciones',
	},
	{
		codigo: '2481',
		descripcion: 'Arquitectos técnicos y técnicos urbanistas',
	},
	{
		codigo: '2482',
		descripcion: 'Diseñadores de productos y de prendas',
	},
	{
		codigo: '2483',
		descripcion: 'Ingenieros técnicos en topografía',
	},
	{
		codigo: '2484',
		descripcion: 'Diseñadores gráficos y multimedia',
	},
	{
		codigo: '2511',
		descripcion: 'Abogados',
	},
	{
		codigo: '2512',
		descripcion: 'Fiscales',
	},
	{
		codigo: '2513',
		descripcion: 'Jueces y magistrados',
	},
	{
		codigo: '2591',
		descripcion: 'Notarios y registradores',
	},
	{
		codigo: '2592',
		descripcion: 'Procuradores',
	},
	{
		codigo: '2599',
		descripcion: 'Profesionales del derecho no clasificados bajo otros epígrafes',
	},
	{
		codigo: '2611',
		descripcion: 'Especialistas en contabilidad',
	},
	{
		codigo: '2612',
		descripcion: 'Asesores financieros y en inversiones',
	},
	{
		codigo: '2613',
		descripcion: 'Analistas financieros',
	},
	{
		codigo: '2621',
		descripcion: 'Analistas de gestión y organización',
	},
	{
		codigo: '2622',
		descripcion: 'Especialistas en administración de política de empresas',
	},
	{
		codigo: '2623',
		descripcion: 'Especialistas de la Administración Pública',
	},
	{
		codigo: '2624',
		descripcion: 'Especialistas en políticas y servicios de personal y afines',
	},
	{
		codigo: '2625',
		descripcion: 'Especialistas en formación de personal',
	},
	{
		codigo: '2630',
		descripcion: 'Técnicos de empresas y actividades turísticas',
	},
	{
		codigo: '2640',
		descripcion: 'Profesionales de ventas técnicas y médicas (excepto las TIC)',
	},
	{
		codigo: '2651',
		descripcion: 'Profesionales de la publicidad y la comercialización',
	},
	{
		codigo: '2652',
		descripcion: 'Profesionales de relaciones públicas',
	},
	{
		codigo: '2653',
		descripcion:
			'Profesionales de la venta de tecnologías de la información y las comunicaciones',
	},
	{
		codigo: '2711',
		descripcion: 'Analistas de sistemas',
	},
	{
		codigo: '2712',
		descripcion: 'Analistas y diseñadores de software',
	},
	{
		codigo: '2713',
		descripcion: 'Analistas, programadores y diseñadores Web y multimedia',
	},
	{
		codigo: '2719',
		descripcion:
			'Analistas y diseñadores de software y multimedia no clasificados bajo otros epígrafes',
	},
	{
		codigo: '2721',
		descripcion: 'Diseñadores y administradores de bases de datos',
	},
	{
		codigo: '2722',
		descripcion: 'Administradores de sistemas y redes',
	},
	{
		codigo: '2723',
		descripcion: 'Analistas de redes informáticas',
	},
	{
		codigo: '2729',
		descripcion:
			'Especialistas en bases de datos y en redes informáticas no clasificados bajo otros epígrafes',
	},
	{
		codigo: '2810',
		descripcion: 'Economistas',
	},
	{
		codigo: '2821',
		descripcion: 'Sociólogos, geógrafos, antropólogos, arqueólogos y afines',
	},
	{
		codigo: '2822',
		descripcion: 'Filósofos, historiadores y profesionales en ciencias políticas',
	},
	{
		codigo: '2823',
		descripcion: 'Psicólogos',
	},
	{
		codigo: '2824',
		descripcion: 'Profesionales del trabajo y la educación social',
	},
	{
		codigo: '2825',
		descripcion: 'Agentes de igualdad de oportunidades entre mujeres y hombres',
	},
	{
		codigo: '2830',
		descripcion: 'Sacerdotes de las distintas religiones',
	},
	{
		codigo: '2911',
		descripcion: 'Archivistas y conservadores de museos',
	},
	{
		codigo: '2912',
		descripcion: 'Bibliotecarios, documentalistas y afines',
	},
	{
		codigo: '2921',
		descripcion: 'Escritores',
	},
	{
		codigo: '2922',
		descripcion: 'Periodistas',
	},
	{
		codigo: '2923',
		descripcion: 'Filólogos, intérpretes y traductores',
	},
	{
		codigo: '2931',
		descripcion: 'Artistas de artes plásticas y visuales',
	},
	{
		codigo: '2932',
		descripcion: 'Compositores, músicos y cantantes',
	},
	{
		codigo: '2933',
		descripcion: 'Coreógrafos y bailarines',
	},
	{
		codigo: '2934',
		descripcion: 'Directores de cine, de teatro y afines',
	},
	{
		codigo: '2935',
		descripcion: 'Actores',
	},
	{
		codigo: '2936',
		descripcion: 'Locutores de radio, televisión y otros presentadores',
	},
	{
		codigo: '2937',
		descripcion: 'Profesionales de espectáculos taurinos',
	},
	{
		codigo: '2939',
		descripcion: 'Artistas creativos e interpretativos no clasificados bajo otros epígrafes',
	},
	{
		codigo: '3110',
		descripcion: 'Delineantes y dibujantes técnicos',
	},
	{
		codigo: '3121',
		descripcion: 'Técnicos en ciencias físicas y químicas',
	},
	{
		codigo: '3122',
		descripcion: 'Técnicos en construcción',
	},
	{
		codigo: '3123',
		descripcion: 'Técnicos en electricidad',
	},
	{
		codigo: '3124',
		descripcion: 'Técnicos en electrónica (excepto electromedicina)',
	},
	{
		codigo: '3125',
		descripcion: 'Técnicos en electrónica, especialidad en electromedicina',
	},
	{
		codigo: '3126',
		descripcion: 'Técnicos en mecánica',
	},
	{
		codigo: '3127',
		descripcion: 'Técnicos y analistas de laboratorio en química industrial',
	},
	{
		codigo: '3128',
		descripcion: 'Técnicos en metalurgia y minas',
	},
	{
		codigo: '3129',
		descripcion:
			'Otros técnicos de las ciencias físicas, químicas, medioambientales y de las ingenierías',
	},
	{
		codigo: '3131',
		descripcion: 'Técnicos en instalaciones de producción de energía',
	},
	{
		codigo: '3132',
		descripcion:
			'Técnicos en instalaciones de tratamiento de residuos, de aguas y otros operadores en plantas similares',
	},
	{
		codigo: '3133',
		descripcion: 'Técnicos en control de instalaciones de procesamiento de productos químicos',
	},
	{
		codigo: '3134',
		descripcion: 'Técnicos de refinerías de petróleo y gas natural',
	},
	{
		codigo: '3135',
		descripcion: 'Técnicos en control de procesos de producción de metales',
	},
	{
		codigo: '3139',
		descripcion: 'Técnicos en control de procesos no clasificados bajo otros epígrafes',
	},
	{
		codigo: '3141',
		descripcion: 'Técnicos en ciencias biológicas (excepto en áreas sanitarias)',
	},
	{
		codigo: '3142',
		descripcion: 'Técnicos agropecuarios',
	},
	{
		codigo: '3143',
		descripcion: 'Técnicos forestales y del medio natural',
	},
	{
		codigo: '3151',
		descripcion: 'Jefes y oficiales de máquinas',
	},
	{
		codigo: '3152',
		descripcion: 'Capitanes y oficiales de puente',
	},
	{
		codigo: '3153',
		descripcion: 'Pilotos de aviación y profesionales afines',
	},
	{
		codigo: '3154',
		descripcion: 'Controladores de tráfico aéreo',
	},
	{
		codigo: '3155',
		descripcion: 'Técnicos en seguridad aeronáutica',
	},
	{
		codigo: '3160',
		descripcion:
			'Técnicos de control de calidad de las ciencias físicas, químicas y de las ingenierías',
	},
	{
		codigo: '3201',
		descripcion: 'Supervisores en ingeniería de minas',
	},
	{
		codigo: '3202',
		descripcion: 'Supervisores de la construcción',
	},
	{
		codigo: '3203',
		descripcion: 'Supervisores de industrias alimenticias y del tabaco',
	},
	{
		codigo: '3204',
		descripcion: 'Supervisores de industrias química y farmacéutica',
	},
	{
		codigo: '3205',
		descripcion:
			'Supervisores de industrias de transformación de plásticos, caucho y resinas naturales',
	},
	{
		codigo: '3206',
		descripcion: 'Supervisores de industrias de la madera y pastero papeleras',
	},
	{
		codigo: '3207',
		descripcion:
			'Supervisores de la producción en industrias de artes gráficas y en la fabricación de productos de papel',
	},
	{
		codigo: '3209',
		descripcion: 'Supervisores de otras industrias manufactureras',
	},
	{
		codigo: '3311',
		descripcion: 'Técnicos en radioterapia',
	},
	{
		codigo: '3312',
		descripcion: 'Técnicos en imagen para el diagnóstico',
	},
	{
		codigo: '3313',
		descripcion: 'Técnicos en anatomía patológica y citología',
	},
	{
		codigo: '3314',
		descripcion: 'Técnicos en laboratorio de diagnóstico clínico',
	},
	{
		codigo: '3315',
		descripcion: 'Técnicos en ortoprótesis',
	},
	{
		codigo: '3316',
		descripcion: 'Técnicos en prótesis dentales',
	},
	{
		codigo: '3317',
		descripcion: 'Técnicos en audioprótesis',
	},
	{
		codigo: '3321',
		descripcion: 'Técnicos superiores en higiene bucodental',
	},
	{
		codigo: '3322',
		descripcion: 'Técnicos superiores en documentación sanitaria',
	},
	{
		codigo: '3323',
		descripcion: 'Técnicos superiores en dietética',
	},
	{
		codigo: '3324',
		descripcion: 'Técnicos en optometría',
	},
	{
		codigo: '3325',
		descripcion: 'Ayudantes fisioterapeutas',
	},
	{
		codigo: '3326',
		descripcion: 'Técnicos en prevención de riesgos laborales y salud ambiental',
	},
	{
		codigo: '3327',
		descripcion: 'Ayudantes de veterinaria',
	},
	{
		codigo: '3329',
		descripcion: 'Técnicos de la sanidad no clasificados bajo otros epígrafes',
	},
	{
		codigo: '3331',
		descripcion:
			'Profesionales de la acupuntura, la naturopatía, la homeopatía, la medicina tradicional china y la ayurveda',
	},
	{
		codigo: '3339',
		descripcion: 'Otros profesionales de las terapias alternativas',
	},
	{
		codigo: '3401',
		descripcion: 'Profesionales de apoyo e intermediarios de cambio, bolsa y finanzas',
	},
	{
		codigo: '3402',
		descripcion: 'Comerciales de préstamos y créditos',
	},
	{
		codigo: '3403',
		descripcion: 'Tenedores de libros',
	},
	{
		codigo: '3404',
		descripcion: 'Profesionales de apoyo en servicios estadísticos, matemáticos y afines',
	},
	{
		codigo: '3405',
		descripcion: 'Tasadores',
	},
	{
		codigo: '3510',
		descripcion: 'Agentes y representantes comerciales',
	},
	{
		codigo: '3521',
		descripcion: 'Mediadores y agentes de seguros',
	},
	{
		codigo: '3522',
		descripcion: 'Agentes de compras',
	},
	{
		codigo: '3523',
		descripcion: 'Consignatarios',
	},
	{
		codigo: '3531',
		descripcion: 'Representantes de aduanas',
	},
	{
		codigo: '3532',
		descripcion: 'Organizadores de conferencias y eventos',
	},
	{
		codigo: '3533',
		descripcion:
			'Agentes o intermediarios en la contratación de la mano de obra (excepto representantes de espectáculos)',
	},
	{
		codigo: '3534',
		descripcion: 'Agentes y administradores de la propiedad inmobiliaria',
	},
	{
		codigo: '3535',
		descripcion: 'Portavoces y agentes de relaciones públicas',
	},
	{
		codigo: '3539',
		descripcion:
			'Representantes artísticos y deportivos y otros agentes de servicios comerciales no clasificados bajo otros epígrafes',
	},
	{
		codigo: '3611',
		descripcion: 'Supervisores de secretaría',
	},
	{
		codigo: '3612',
		descripcion: 'Asistentes jurídico-legales',
	},
	{
		codigo: '3613',
		descripcion: 'Asistentes de dirección y administrativos',
	},
	{
		codigo: '3614',
		descripcion: 'Secretarios de centros médicos o clínicas',
	},
	{
		codigo: '3621',
		descripcion: 'Profesionales de apoyo de la Administración Pública de tributos',
	},
	{
		codigo: '3622',
		descripcion: 'Profesionales de apoyo de la Administración Pública de servicios sociales',
	},
	{
		codigo: '3623',
		descripcion:
			'Profesionales de apoyo de la Administración Pública de servicios de expedición de licencias',
	},
	{
		codigo: '3629',
		descripcion:
			'Otros profesionales de apoyo de la Administración Pública para tareas de inspección y control y tareas similares',
	},
	{
		codigo: '3631',
		descripcion: 'Técnicos de la policía nacional, autonómica y local',
	},
	{
		codigo: '3632',
		descripcion: 'Suboficiales de la guardia civil',
	},
	{
		codigo: '3711',
		descripcion: 'Profesionales de apoyo de servicios jurídicos y servicios similares',
	},
	{
		codigo: '3712',
		descripcion: 'Detectives privados',
	},
	{
		codigo: '3713',
		descripcion: 'Profesionales de apoyo al trabajo y a la educación social',
	},
	{
		codigo: '3714',
		descripcion: 'Promotores de igualdad de oportunidades entre mujeres y hombres',
	},
	{
		codigo: '3715',
		descripcion: 'Animadores comunitarios',
	},
	{
		codigo: '3716',
		descripcion: 'Auxiliares laicos de las religiones',
	},
	{
		codigo: '3721',
		descripcion: 'Atletas y deportistas',
	},
	{
		codigo: '3722',
		descripcion: 'Entrenadores y árbitros de actividades deportivas',
	},
	{
		codigo: '3723',
		descripcion: 'Instructores de actividades deportivas',
	},
	{
		codigo: '3724',
		descripcion: 'Monitores de actividades recreativas y de entretenimiento',
	},
	{
		codigo: '3731',
		descripcion: 'Fotógrafos',
	},
	{
		codigo: '3732',
		descripcion: 'Diseñadores y decoradores de interior',
	},
	{
		codigo: '3733',
		descripcion: 'Técnicos en galerías de arte, museos y bibliotecas',
	},
	{
		codigo: '3734',
		descripcion: 'Chefs',
	},
	{
		codigo: '3739',
		descripcion:
			'Otros técnicos y profesionales de apoyo de actividades culturales y artísticas',
	},
	{
		codigo: '3811',
		descripcion: 'Técnicos en operaciones de sistemas informáticos',
	},
	{
		codigo: '3812',
		descripcion: 'Técnicos en asistencia al usuario de tecnologías de la información',
	},
	{
		codigo: '3813',
		descripcion: 'Técnicos en redes',
	},
	{
		codigo: '3814',
		descripcion: 'Técnicos de la Web',
	},
	{
		codigo: '3820',
		descripcion: 'Programadores informáticos',
	},
	{
		codigo: '3831',
		descripcion: 'Técnicos de grabación audiovisual',
	},
	{
		codigo: '3832',
		descripcion: 'Técnicos de radiodifusión',
	},
	{
		codigo: '3833',
		descripcion: 'Técnicos de ingeniería de las telecomunicaciones',
	},
	{
		codigo: '4113',
		descripcion: 'Empleados de oficina de servicios estadísticos, financieros y bancarios',
	},
	{
		codigo: '4121',
		descripcion: 'Empleados de control de abastecimientos e inventario',
	},
	{
		codigo: '4122',
		descripcion: 'Empleados de oficina de servicios de apoyo a la producción',
	},
	{
		codigo: '4123',
		descripcion: 'Empleados de logística y transporte de pasajeros y mercancías',
	},
	{
		codigo: '4210',
		descripcion: 'Empleados de bibliotecas y archivos',
	},
	{
		codigo: '4221',
		descripcion: 'Empleados de servicios de correos (excepto empleados de mostrador)',
	},
	{
		codigo: '4222',
		descripcion: 'Codificadores y correctores de imprenta',
	},
	{
		codigo: '4223',
		descripcion: 'Empleados de servicio de personal',
	},
	{
		codigo: '4309',
		descripcion:
			'Empleados administrativos sin tareas de atención al público no clasificados bajo otros epígrafes',
	},
	{
		codigo: '4411',
		descripcion: 'Empleados de información al usuario',
	},
	{
		codigo: '4412',
		descripcion: 'Recepcionistas (excepto de hoteles)',
	},
	{
		codigo: '4421',
		descripcion: 'Empleados de agencias de viajes',
	},
	{
		codigo: '4422',
		descripcion: 'Recepcionistas de hoteles',
	},
	{
		codigo: '4423',
		descripcion: 'Telefonistas',
	},
	{
		codigo: '4424',
		descripcion: 'Teleoperadores',
	},
	{
		codigo: '4430',
		descripcion: 'Agentes de encuestas',
	},
	{
		codigo: '4441',
		descripcion: 'Cajeros de bancos y afines',
	},
	{
		codigo: '4442',
		descripcion: 'Empleados de venta de apuestas',
	},
	{
		codigo: '4443',
		descripcion: 'Empleados de sala de juegos y afines',
	},
	{
		codigo: '4444',
		descripcion: 'Empleados de casas de empeño y de préstamos',
	},
	{
		codigo: '4445',
		descripcion: 'Cobradores de facturas, deudas y empleados afines',
	},
	{
		codigo: '4446',
		descripcion: 'Empleados de mostrador de correos',
	},
	{
		codigo: '4500',
		descripcion:
			'Empleados administrativos con tareas de atención al público no clasificados bajo otros epígrafes',
	},
	{
		codigo: '5000',
		descripcion: 'Camareros y cocineros propietarios',
	},
	{
		codigo: '5110',
		descripcion: 'Cocineros asalariados',
	},
	{
		codigo: '5120',
		descripcion: 'Camareros asalariados',
	},
	{
		codigo: '5210',
		descripcion: 'Jefes de sección de tiendas y almacenes',
	},
	{
		codigo: '5220',
		descripcion: 'Vendedores en tiendas y almacenes',
	},
	{
		codigo: '5300',
		descripcion: 'Comerciantes propietarios de tiendas',
	},
	{
		codigo: '5411',
		descripcion: 'Vendedores en quioscos',
	},
	{
		codigo: '5412',
		descripcion: 'Vendedores en mercados ocasionales y mercadillos',
	},
	{
		codigo: '5420',
		descripcion: 'Operadores de telemarketing',
	},
	{
		codigo: '5430',
		descripcion: 'Expendedores de gasolineras',
	},
	{
		codigo: '5491',
		descripcion: 'Vendedores a domicilio',
	},
	{
		codigo: '5492',
		descripcion: 'Promotores de venta',
	},
	{
		codigo: '5493',
		descripcion: 'Modelos de moda, arte y publicidad',
	},
	{
		codigo: '5499',
		descripcion: 'Vendedores no clasificados bajo otros epígrafes',
	},
	{
		codigo: '5500',
		descripcion: 'Cajeros y taquilleros (excepto bancos)',
	},
	{
		codigo: '5611',
		descripcion: 'Auxiliares de enfermería hospitalaria',
	},
	{
		codigo: '5612',
		descripcion: 'Auxiliares de enfermería de atención primaria',
	},
	{
		codigo: '5621',
		descripcion: 'Técnicos auxiliares de farmacia',
	},
	{
		codigo: '5622',
		descripcion: 'Técnicos de emergencias sanitarias',
	},
	{
		codigo: '5710',
		descripcion: 'Trabajadores de los cuidados personales a domicilio',
	},
	{
		codigo: '5721',
		descripcion: 'Cuidadores de niños en guarderías y centros educativos',
	},
	{
		codigo: '5722',
		descripcion: 'Cuidadores de niños en domicilios',
	},
	{
		codigo: '5811',
		descripcion: 'Peluqueros',
	},
	{
		codigo: '5812',
		descripcion: 'Especialistas en tratamientos de estética, bienestar y afines',
	},
	{
		codigo: '5821',
		descripcion: 'Auxiliares de vuelo y camareros de avión, barco y tren',
	},
	{
		codigo: '5822',
		descripcion: 'Revisores y cobradores de transporte terrestre',
	},
	{
		codigo: '5823',
		descripcion: 'Acompañantes turísticos',
	},
	{
		codigo: '5824',
		descripcion: 'Azafatos de tierra',
	},
	{
		codigo: '5825',
		descripcion: 'Guías de turismo',
	},
	{
		codigo: '5831',
		descripcion:
			'Supervisores de mantenimiento y limpieza en oficinas, hoteles y otros establecimientos',
	},
	{
		codigo: '5832',
		descripcion: 'Mayordomos del servicio doméstico',
	},
	{
		codigo: '5833',
		descripcion: 'Conserjes de edificios',
	},
	{
		codigo: '5840',
		descripcion: 'Trabajadores propietarios de pequeños alojamientos',
	},
	{
		codigo: '5891',
		descripcion: 'Asistentes personales o personas de compañía',
	},
	{
		codigo: '5892',
		descripcion: 'Empleados de pompas fúnebres y embalsamadores',
	},
	{
		codigo: '5893',
		descripcion: 'Cuidadores de animales y adiestradores',
	},
	{
		codigo: '5894',
		descripcion: 'Instructores de autoescuela',
	},
	{
		codigo: '5895',
		descripcion: 'Astrólogos, adivinadores y afines',
	},
	{
		codigo: '5899',
		descripcion: 'Trabajadores de servicios personales no clasificados bajo otros epígrafes',
	},
	{
		codigo: '5910',
		descripcion: 'Guardias civiles',
	},
	{
		codigo: '5921',
		descripcion: 'Policías nacionales',
	},
	{
		codigo: '5922',
		descripcion: 'Policías autonómicos',
	},
	{
		codigo: '5923',
		descripcion: 'Policías locales',
	},
	{
		codigo: '5931',
		descripcion: 'Bomberos (excepto forestales)',
	},
	{
		codigo: '5932',
		descripcion: 'Bomberos forestales',
	},
	{
		codigo: '5941',
		descripcion: 'Vigilantes de seguridad y similares habilitados para ir armados',
	},
	{
		codigo: '5942',
		descripcion:
			'Auxiliares de vigilante de seguridad y similares no habilitados para ir armados',
	},
	{
		codigo: '5991',
		descripcion: 'Vigilantes de prisiones',
	},
	{
		codigo: '5992',
		descripcion: 'Bañistas-socorristas',
	},
	{
		codigo: '5993',
		descripcion: 'Agentes forestales y medioambientales',
	},
	{
		codigo: '5999',
		descripcion:
			'Trabajadores de los servicios de protección y seguridad no clasificados bajo otros epígrafes',
	},
	{
		codigo: '6110',
		descripcion:
			'Trabajadores cualificados en actividades agrícolas (excepto en huertas, invernaderos, viveros y jardines)',
	},
	{
		codigo: '6120',
		descripcion: 'Trabajadores cualificados en huertas, invernaderos, viveros y jardines',
	},
	{
		codigo: '6202',
		descripcion: 'Trabajadores cualificados en actividades ganaderas de ovino y caprino',
	},
	{
		codigo: '6300',
		descripcion: 'Trabajadores cualificados en actividades agropecuarias mixtas',
	},
	{
		codigo: '6410',
		descripcion: 'Trabajadores cualificados en actividades forestales y del medio natural',
	},
	{
		codigo: '6421',
		descripcion: 'Trabajadores cualificados en la acuicultura',
	},
	{
		codigo: '6422',
		descripcion: 'Pescadores de aguas costeras y aguas dulces',
	},
	{
		codigo: '6423',
		descripcion: 'Pescadores de altura',
	},
	{
		codigo: '6430',
		descripcion: 'Trabajadores cualificados en actividades cinegéticas',
	},
	{
		codigo: '7111',
		descripcion: 'Encofradores y operarios de puesta en obra de hormigón',
	},
	{
		codigo: '7191',
		descripcion: 'Mantenedores de edificios',
	},
	{
		codigo: '7192',
		descripcion: 'Instaladores de fachadas técnicas',
	},
	{
		codigo: '7193',
		descripcion: 'Instaladores de sistemas de impermeabilización en edificios',
	},
	{
		codigo: '7199',
		descripcion:
			'Otros trabajadores de las obras estructurales de construcción no clasificados bajo otros epígrafes',
	},
	{
		codigo: '7292',
		descripcion: 'Instaladores de material aislante térmico y de insonorización',
	},
	{
		codigo: '7322',
		descripcion:
			'Trabajadores de la fabricación de herramientas, mecánico-ajustadores, modelistas, matriceros y afines',
	},
	{
		codigo: '7709',
		descripcion: 'Catadores y clasificadores de alimentos y bebidas',
	},
	{
		codigo: '7891',
		descripcion: 'Buceadores',
	},
	{
		codigo: '7892',
		descripcion: 'Pegadores',
	},
	{
		codigo: '7893',
		descripcion:
			'Clasificadores y probadores de productos (excepto alimentos, bebidas y tabaco)',
	},
	{
		codigo: '7894',
		descripcion: 'Fumigadores y otros controladores de plagas y malas hierbas',
	},
	{
		codigo: '7899',
		descripcion:
			'Oficiales, operarios y artesanos de otros oficios no clasificados bajo otros epígrafes',
	},
	{
		codigo: '8133',
		descripcion: 'Operadores de laboratorios fotográficos y afines',
	},
	{
		codigo: '8170',
		descripcion: 'Operadores de máquinas de lavandería y tintorería',
	},
	{
		codigo: '8201',
		descripcion: 'Ensambladores de maquinaria mecánica',
	},
	{
		codigo: '8202',
		descripcion: 'Ensambladores de equipos eléctricos y electrónicos',
	},
	{
		codigo: '8209',
		descripcion: 'Montadores y ensambladores no clasificados en otros epígrafes',
	},
	{
		codigo: '8321',
		descripcion: 'Operadores de maquinaria agrícola móvil',
	},
	{
		codigo: '8322',
		descripcion: 'Operadores de maquinaria forestal móvil',
	},
	{
		codigo: '8340',
		descripcion: 'Marineros de puente, marineros de máquinas y afines',
	},
	{
		codigo: '8411',
		descripcion: 'Conductores propietarios de automóviles, taxis y furgonetas',
	},
	{
		codigo: '8412',
		descripcion: 'Conductores asalariados de automóviles, taxis y furgonetas',
	},
	{
		codigo: '8431',
		descripcion: 'Conductores propietarios de camiones',
	},
	{
		codigo: '8432',
		descripcion: 'Conductores asalariados de camiones',
	},
	{
		codigo: '9100',
		descripcion: 'Empleados domésticos',
	},
	{
		codigo: '9210',
		descripcion: 'Personal de limpieza de oficinas, hoteles y otros establecimientos similares',
	},
	{
		codigo: '9221',
		descripcion: 'Limpiadores en seco a mano y afines',
	},
	{
		codigo: '9222',
		descripcion: 'Limpiadores de vehículos',
	},
	{
		codigo: '9223',
		descripcion: 'Limpiadores de ventanas',
	},
	{
		codigo: '9229',
		descripcion: 'Otro personal de limpieza',
	},
	{
		codigo: '9310',
		descripcion: 'Ayudantes de cocina',
	},
	{
		codigo: '9320',
		descripcion: 'Preparadores de comidas rápidas',
	},
	{
		codigo: '9410',
		descripcion: 'Vendedores callejeros',
	},
	{
		codigo: '9420',
		descripcion:
			'Repartidores de publicidad, limpiabotas y otros trabajadores de oficios callejeros',
	},
	{
		codigo: '9431',
		descripcion: 'Ordenanzas',
	},
	{
		codigo: '9432',
		descripcion: 'Mozos de equipaje y afines',
	},
	{
		codigo: '9433',
		descripcion: 'Repartidores, recadistas y mensajeros a pie',
	},
	{
		codigo: '9434',
		descripcion: 'Lectores de contadores y recaudadores de máquinas recreativas y expendedoras',
	},
	{
		codigo: '9441',
		descripcion: 'Recogedores de residuos',
	},
	{
		codigo: '9442',
		descripcion:
			'Clasificadores de desechos, operarios de punto limpio y recogedores de chatarra',
	},
	{
		codigo: '9443',
		descripcion: 'Barrenderos y afines',
	},
	{
		codigo: '9490',
		descripcion: 'Otras ocupaciones elementales',
	},
	{
		codigo: '9511',
		descripcion: 'Peones agrícolas (excepto en huertas, invernaderos, viveros y jardines)',
	},
	{
		codigo: '9512',
		descripcion: 'Peones agrícolas en huertas, invernaderos, viveros y jardines',
	},
	{
		codigo: '9520',
		descripcion: 'Peones ganaderos',
	},
	{
		codigo: '9530',
		descripcion: 'Peones agropecuarios',
	},
	{
		codigo: '9541',
		descripcion: 'Peones de la pesca',
	},
	{
		codigo: '9542',
		descripcion: 'Peones de la acuicultura',
	},
	{
		codigo: '9543',
		descripcion: 'Peones forestales y de la caza',
	},
	{
		codigo: '9601',
		descripcion: 'Peones de obras públicas',
	},
	{
		codigo: '9602',
		descripcion: 'Peones de la construcción de edificios',
	},
	{
		codigo: '9603',
		descripcion: 'Peones de la minería, canteras y otras industrias extractivas',
	},
	{
		codigo: '9700',
		descripcion: 'Peones de las industrias manufactureras',
	},
	{
		codigo: '9811',
		descripcion: 'Peones del transporte de mercancías y descargadores',
	},
	{
		codigo: '9812',
		descripcion:
			'Conductores de vehículos de tracción animal para el transporte de personas y similares',
	},
	{
		codigo: '9820',
		descripcion: 'Reponedores',
	},
	{
		codigo: '0011',
		descripcion: 'Oficiales de las fuerzas armadas',
	},
	{
		codigo: '0012',
		descripcion: 'Suboficiales de las fuerzas armadas',
	},
	{
		codigo: '0020',
		descripcion: 'Tropa y marinería de las fuerzas armadas',
	},
	{
		codigo: '1111',
		descripcion:
			'Miembros del poder ejecutivo (nacional, autonómico y local) y del poder legislativo',
	},
	{
		codigo: '1112',
		descripcion: 'Personal directivo de la Administración Pública',
	},
	{
		codigo: '1120',
		descripcion: 'Directores generales y presidentes ejecutivos',
	},
	{
		codigo: '1211',
		descripcion: 'Directores financieros',
	},
	{
		codigo: '1212',
		descripcion: 'Directores de recursos humanos',
	},
	{
		codigo: '1219',
		descripcion:
			'Directores de políticas y planificación y de otros departamentos administrativos no clasificados bajo otros epígrafes',
	},
	{
		codigo: '1221',
		descripcion: 'Directores comerciales y de ventas',
	},
	{
		codigo: '1222',
		descripcion: 'Directores de publicidad y relaciones públicas',
	},
	{
		codigo: '1223',
		descripcion: 'Directores de investigación y desarrollo',
	},
	{
		codigo: '1311',
		descripcion: 'Directores de producción de explotaciones agropecuarias y forestales',
	},
	{
		codigo: '1312',
		descripcion: 'Directores de producción de explotaciones pesqueras y acuícolas',
	},
	{
		codigo: '1313',
		descripcion: 'Directores de industrias manufactureras',
	},
	{
		codigo: '1314',
		descripcion: 'Directores de explotaciones mineras',
	},
	{
		codigo: '1315',
		descripcion: 'Directores de empresas de abastecimiento, transporte, distribución y afines',
	},
	{
		codigo: '1316',
		descripcion: 'Directores de empresas de construcción',
	},
	{
		codigo: '1321',
		descripcion:
			'Directores de servicios de tecnologías de la información y las comunicaciones (TIC)',
	},
	{
		codigo: '1322',
		descripcion: 'Directores de servicios sociales para niños',
	},
	{
		codigo: '1323',
		descripcion: 'Directores-gerentes de centros sanitarios',
	},
	{
		codigo: '1324',
		descripcion: 'Directores de servicios sociales para personas mayores',
	},
	{
		codigo: '1325',
		descripcion: 'Directores de otros servicios sociales',
	},
	{
		codigo: '1326',
		descripcion: 'Directores de servicios de educación',
	},
	{
		codigo: '1327',
		descripcion: 'Directores de sucursales de bancos, de servicios financieros y de seguros',
	},
	{
		codigo: '1329',
		descripcion:
			'Directores de otras empresas de servicios profesionales no clasificados bajo otros epígrafes',
	},
	{
		codigo: '1411',
		descripcion: 'Directores y gerentes de hoteles',
	},
	{
		codigo: '1419',
		descripcion: 'Directores y gerentes de otras empresas de servicios de alojamiento',
	},
	{
		codigo: '1421',
		descripcion: 'Directores y gerentes de restaurantes',
	},
	{
		codigo: '1422',
		descripcion: 'Directores y gerentes de bares, cafeterías y similares',
	},
	{
		codigo: '1431',
		descripcion: 'Directores y gerentes de empresas de comercio al por mayor',
	},
	{
		codigo: '1432',
		descripcion: 'Directores y gerentes de empresas de comercio al por menor',
	},
	{
		codigo: '2111',
		descripcion: 'Médicos de familia',
	},
	{
		codigo: '2112',
		descripcion: 'Otros médicos especialistas',
	},
	{
		codigo: '2121',
		descripcion: 'Enfermeros no especializados',
	},
	{
		codigo: '2122',
		descripcion: 'Enfermeros especializados (excepto matronos)',
	},
	{
		codigo: '2123',
		descripcion: 'Matronos',
	},
	{
		codigo: '2220',
		descripcion: 'Profesores de formación profesional (materias específicas)',
	},
	{
		codigo: '2230',
		descripcion:
			'Profesores de enseñanza secundaria (excepto materias específicas de formación profesional)',
	},
	{
		codigo: '2240',
		descripcion: 'Profesores de enseñanza primaria',
	},
	{
		codigo: '2251',
		descripcion: 'Maestros de educación infantil',
	},
	{
		codigo: '2252',
		descripcion: 'Técnicos en educación infantil',
	},
	{
		codigo: '2311',
		descripcion: 'Profesores de educación especial',
	},
	{
		codigo: '2312',
		descripcion: 'Técnicos educadores de educación especial',
	},
	{
		codigo: '2321',
		descripcion: 'Especialistas en métodos didácticos y pedagógicos',
	},
	{
		codigo: '2322',
		descripcion: 'Profesores de enseñanza no reglada de idiomas',
	},
	{
		codigo: '2323',
		descripcion: 'Profesores de enseñanza no reglada de música y danza',
	},
	{
		codigo: '2324',
		descripcion: 'Profesores de enseñanza no reglada de artes',
	},
	{
		codigo: '2325',
		descripcion: 'Instructores en tecnologías de la información en enseñanza no reglada',
	},
	{
		codigo: '2326',
		descripcion: 'Profesionales de la educación ambiental',
	},
	{
		codigo: '2329',
		descripcion:
			'Profesores y profesionales de la enseñanza no clasificados bajo otros epígrafes',
	},
	{
		codigo: '4111',
		descripcion: 'Empleados de contabilidad',
	},
	{
		codigo: '4112',
		descripcion: 'Empleados de control de personal y nóminas',
	},
	{
		codigo: '4301',
		descripcion: 'Grabadores de datos',
	},
	{
		codigo: '5629',
		descripcion:
			'Trabajadores de los cuidados a las personas en servicios de salud no clasificados bajo otros epígrafes',
	},
	{
		codigo: '6201',
		descripcion: 'Trabajadores cualificados en actividades ganaderas de vacuno',
	},
	{
		codigo: '6203',
		descripcion: 'Trabajadores cualificados en actividades ganaderas de porcino',
	},
	{
		codigo: '6204',
		descripcion: 'Trabajadores cualificados en apicultura y sericicultura',
	},
	{
		codigo: '6205',
		descripcion: 'Trabajadores cualificados en la avicultura y la cunicultura',
	},
	{
		codigo: '6209',
		descripcion:
			'Trabajadores cualificados en actividades ganaderas no clasificados bajo otros epígrafes',
	},
	{
		codigo: '7112',
		descripcion: 'Montadores de prefabricados estructurales (sólo hormigón)',
	},
	{
		codigo: '7121',
		descripcion: 'Albañiles',
	},
	{
		codigo: '7122',
		descripcion: 'Canteros, tronzadores, labrantes y grabadores de piedras',
	},
	{
		codigo: '7131',
		descripcion: 'Carpinteros (excepto ebanistas)',
	},
	{
		codigo: '7132',
		descripcion:
			'Instaladores de cerramientos metálicos y carpinteros metálicos (excepto montadores de estructuras metálicas)',
	},
	{
		codigo: '7211',
		descripcion: 'Escayolistas',
	},
	{
		codigo: '7212',
		descripcion: 'Aplicadores de revestimientos de pasta y mortero',
	},
	{
		codigo: '7221',
		descripcion: 'Fontaneros',
	},
	{
		codigo: '7222',
		descripcion: 'Montadores-instaladores de gas en edificios',
	},
	{
		codigo: '7223',
		descripcion: 'Instaladores de conductos en obra pública',
	},
	{
		codigo: '7231',
		descripcion: 'Pintores y empapeladores',
	},
	{
		codigo: '7232',
		descripcion: 'Pintores en las industrias manufactureras',
	},
	{
		codigo: '7240',
		descripcion: 'Soladores, colocadores de parquet y afines',
	},
	{
		codigo: '7250',
		descripcion: 'Mecánicos-instaladores de refrigeración y climatización',
	},
	{
		codigo: '7291',
		descripcion: 'Montadores de cubiertas',
	},
	{
		codigo: '7293',
		descripcion: 'Cristaleros',
	},
	{
		codigo: '7294',
		descripcion: 'Montadores-instaladores de placas de energía solar',
	},
	{
		codigo: '7295',
		descripcion: 'Personal de limpieza de fachadas de edificios y chimeneas',
	},
	{
		codigo: '7311',
		descripcion: 'Moldeadores y macheros',
	},
	{
		codigo: '7312',
		descripcion: 'Soldadores y oxicortadores',
	},
	{
		codigo: '7313',
		descripcion: 'Chapistas y caldereros',
	},
	{
		codigo: '7314',
		descripcion: 'Montadores de estructuras metálicas',
	},
	{
		codigo: '7315',
		descripcion: 'Montadores de estructuras cableadas y empalmadores de cables',
	},
	{
		codigo: '7321',
		descripcion: 'Herreros y forjadores',
	},
	{
		codigo: '7323',
		descripcion: 'Ajustadores y operadores de máquinas-herramienta',
	},
	{
		codigo: '7324',
		descripcion: 'Pulidores de metales y afiladores de herramientas',
	},
	{
		codigo: '7401',
		descripcion: 'Mecánicos y ajustadores de vehículos de motor',
	},
	{
		codigo: '7402',
		descripcion: 'Mecánicos y ajustadores de motores de avión',
	},
	{
		codigo: '7403',
		descripcion: 'Mecánicos y ajustadores de maquinaria agrícola e industrial',
	},
	{
		codigo: '7404',
		descripcion: 'Mecánicos y ajustadores de maquinaria naval y ferroviaria',
	},
	{
		codigo: '7405',
		descripcion: 'Reparadores de bicicletas y afines',
	},
	{
		codigo: '7510',
		descripcion: 'Electricistas de la construcción y afines',
	},
	{
		codigo: '7521',
		descripcion: 'Mecánicos y reparadores de equipos eléctricos',
	},
	{
		codigo: '7522',
		descripcion: 'Instaladores y reparadores de líneas eléctricas',
	},
	{
		codigo: '7531',
		descripcion: 'Mecánicos y reparadores de equipos electrónicos',
	},
	{
		codigo: '7532',
		descripcion: 'Instaladores y reparadores en electromedicina',
	},
	{
		codigo: '7533',
		descripcion:
			'Instaladores y reparadores en tecnologías de la información y las comunicaciones',
	},
	{
		codigo: '7611',
		descripcion: 'Relojeros y mecánicos de instrumentos de precisión',
	},
	{
		codigo: '7612',
		descripcion: 'Lutieres y similares; afinadores de instrumentos musicales',
	},
	{
		codigo: '7613',
		descripcion: 'Joyeros, orfebres y plateros',
	},
	{
		codigo: '7614',
		descripcion: 'Trabajadores de la cerámica, alfareros y afines',
	},
	{
		codigo: '7615',
		descripcion: 'Sopladores, modeladores, laminadores, cortadores y pulidores de vidrio',
	},
	{
		codigo: '7616',
		descripcion: 'Rotulistas, grabadores de vidrio, pintores decorativos de artículos diversos',
	},
	{
		codigo: '7617',
		descripcion:
			'Artesanos en madera y materiales similares; cesteros, bruceros y trabajadores afines',
	},
	{
		codigo: '7618',
		descripcion:
			'Artesanos en tejidos, cueros y materiales similares, preparadores de fibra y tejedores con telares artesanos o de tejidos de punto y afines',
	},
	{
		codigo: '7619',
		descripcion: 'Artesanos no clasificados bajo otros epígrafes',
	},
	{
		codigo: '7621',
		descripcion: 'Trabajadores de procesos de preimpresión',
	},
	{
		codigo: '7622',
		descripcion: 'Trabajadores de procesos de impresión',
	},
	{
		codigo: '7623',
		descripcion: 'Trabajadores de procesos de encuadernación',
	},
	{
		codigo: '7701',
		descripcion: 'Matarifes y trabajadores de las industrias cárnicas',
	},
	{
		codigo: '7702',
		descripcion: 'Trabajadores de las industrias del pescado',
	},
	{
		codigo: '7703',
		descripcion: 'Panaderos, pasteleros y confiteros',
	},
	{
		codigo: '7704',
		descripcion:
			'Trabajadores del tratamiento de la leche y elaboración de productos lácteos (incluidos helados)',
	},
	{
		codigo: '7705',
		descripcion:
			'Trabajadores conserveros de frutas y hortalizas y trabajadores de la elaboración de bebidas no alcohólicas',
	},
	{
		codigo: '7706',
		descripcion: 'Trabajadores de la elaboración de bebidas alcohólicas distintas del vino',
	},
	{
		codigo: '7707',
		descripcion: 'Trabajadores de la elaboración del vino',
	},
	{
		codigo: '7708',
		descripcion: 'Preparadores y elaboradores del tabaco y sus productos',
	},
	{
		codigo: '7811',
		descripcion: 'Trabajadores del tratamiento de la madera',
	},
	{
		codigo: '7812',
		descripcion: 'Ajustadores y operadores de máquinas para trabajar la madera',
	},
	{
		codigo: '7820',
		descripcion: 'Ebanistas y trabajadores afines',
	},
	{
		codigo: '7831',
		descripcion: 'Sastres, modistos, peleteros y sombrereros',
	},
	{
		codigo: '7832',
		descripcion: 'Patronistas para productos en textil y piel',
	},
	{
		codigo: '7833',
		descripcion: 'Cortadores de tejidos, cuero, piel y otros materiales',
	},
	{
		codigo: '7834',
		descripcion: 'Costureros a mano, bordadores y afines',
	},
	{
		codigo: '7835',
		descripcion: 'Tapiceros, colchoneros y afines',
	},
	{
		codigo: '7836',
		descripcion: 'Curtidores y preparadores de pieles',
	},
	{
		codigo: '7837',
		descripcion: 'Zapateros y afines',
	},
	{
		codigo: '8111',
		descripcion: 'Mineros y otros operadores en instalaciones mineras',
	},
	{
		codigo: '8112',
		descripcion: 'Operadores en instalaciones para la preparación de minerales y rocas',
	},
	{
		codigo: '8113',
		descripcion: 'Sondistas y trabajadores afines',
	},
	{
		codigo: '8114',
		descripcion:
			'Operadores de maquinaria para fabricar productos derivados de minerales no metálicos',
	},
	{
		codigo: '8121',
		descripcion: 'Operadores en instalaciones para la obtención y transformación de metales',
	},
	{
		codigo: '8122',
		descripcion: 'Operadores de máquinas pulidoras, galvanizadoras y recubridoras de metales',
	},
	{
		codigo: '8131',
		descripcion: 'Operadores en plantas industriales químicas',
	},
	{
		codigo: '8132',
		descripcion:
			'Operadores de máquinas para fabricar productos farmacéuticos, cosméticos y afines',
	},
	{
		codigo: '8141',
		descripcion:
			'Operadores de máquinas para fabricar productos de caucho y derivados de resinas naturales',
	},
	{
		codigo: '8142',
		descripcion: 'Operadores de máquinas para fabricar productos de material plástico',
	},
	{
		codigo: '8143',
		descripcion: 'Operadores de máquinas para fabricar productos de papel y cartón',
	},
	{
		codigo: '8144',
		descripcion:
			'Operadores de serrerías, de máquinas de fabricación de tableros y de instalaciones afines para el tratamiento de la madera y el corcho',
	},
	{
		codigo: '8145',
		descripcion:
			'Operadores en instalaciones para la preparación de pasta de papel y fabricación de papel',
	},
	{
		codigo: '8151',
		descripcion: 'Operadores de máquinas para preparar fibras, hilar y devanar',
	},
	{
		codigo: '8152',
		descripcion: 'Operadores de telares y otras máquinas tejedoras',
	},
	{
		codigo: '8153',
		descripcion: 'Operadores de máquinas de coser y bordar',
	},
	{
		codigo: '8154',
		descripcion: 'Operadores de máquinas de blanquear, teñir, estampar y acabar textiles',
	},
	{
		codigo: '8155',
		descripcion: 'Operadores de máquinas para tratar pieles y cuero',
	},
	{
		codigo: '8156',
		descripcion:
			'Operadores de máquinas para la fabricación del calzado, marroquinería y guantería de piel',
	},
	{
		codigo: '8159',
		descripcion:
			'Operadores de máquinas para fabricar productos textiles no clasificados bajo otros epígrafes',
	},
	{
		codigo: '8160',
		descripcion:
			'Operadores de máquinas para elaborar productos alimenticios, bebidas y tabaco',
	},
	{
		codigo: '8191',
		descripcion: 'Operadores de hornos e instalaciones de vidriería y cerámica',
	},
	{
		codigo: '8192',
		descripcion: 'Operadores de calderas y máquinas de vapor',
	},
	{
		codigo: '8193',
		descripcion: 'Operadores de máquinas de embalaje, embotellamiento y etiquetado',
	},
	{
		codigo: '8199',
		descripcion:
			'Operadores de instalaciones y maquinaria fijas no clasificados bajo otros epígrafes',
	},
	{
		codigo: '8311',
		descripcion: 'Maquinistas de locomotoras',
	},
	{
		codigo: '8312',
		descripcion: 'Agentes de maniobras ferroviarias',
	},
	{
		codigo: '8331',
		descripcion: 'Operadores de maquinaria de movimientos de tierras y equipos similares',
	},
	{
		codigo: '8332',
		descripcion:
			'Operadores de grúas, montacargas y de maquinaria similar de movimiento de materiales',
	},
	{
		codigo: '8333',
		descripcion: 'Operadores de carretillas elevadoras',
	},
	{
		codigo: '8420',
		descripcion: 'Conductores de autobuses y tranvías',
	},
	{
		codigo: '8440',
		descripcion: 'Conductores de motocicletas y ciclomotores',
	},
].map((x) => ({ NAME: x.descripcion, VALUE: x.codigo }));

export const professionsTypes = professionsList.reduce((acc, item) => {
	acc[item.NAME] = item.VALUE;
	return acc;
}, {});
